<template>
  <v-container class="pt-4 pb-8">
    <div class="box-wrapper">
      <div class="box-overlay" :class="{'open': isSidebar}" @click="isSidebar = !isSidebar"></div>
      <div class="box-sidebar pb-3 shadow-sm" :class="{'open': isSidebar}">
        <PanelSidebar/>
      </div>
      <div class="box-content">
        <div class="d-flex justify-end pa-2 d-block d-md-none">
          <v-btn
              icon
              @click="isSidebar = !isSidebar"
          >
            <v-icon dark>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </div>
        <div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>

import PanelSidebar from "@/views/StorePanel/Component/Sidebar";

export default {
  name: "StorePanel",
  components: {
    PanelSidebar
  },
  data() {
    return {
      isSidebar: false,
    }
  },

}
</script>